module.exports = __webpack_public_path__ + "img/score4.8728e599.webp";